import { useNavigate } from "react-router-dom";
import { ReactComponent as LeftArrow } from "../../assets/icons/leftArrow.svg";
import closeIcon from "../../assets/icons/close_black.svg";
import { twMerge } from "tailwind-merge";

type Props = {
    title?: string;
    goBack?: boolean;
    close?: () => void;
    onClickClose?: () => void;
    onClickGoBack?: () => void;
    className?: string;
};

export default function Header({ title, goBack, onClickClose, onClickGoBack, className }: Props) {
    const navigate = useNavigate();
    const style = twMerge("relative py-[15px] font-bold text-[20px] text-center w-full", className);
    return (
        <header className={style}>
            {goBack && (
                <button
                    type="button"
                    onClick={() => (onClickGoBack ? onClickGoBack() : navigate(-1))}
                    className="absolute left-[40px] top-1/2 -translate-y-1/2 cursor-pointer mobile450:left-[20px]"
                >
                    <LeftArrow />
                    <span className="indent-[-9999em] absolute h-0">뒤로가기</span>
                </button>
            )}
            <p className="leading-[30px] min-h-[30px]">{title && title}</p>

            {onClickClose && (
                <button
                    type="button"
                    onClick={onClickClose}
                    className="absolute right-[40px] top-1/2 -translate-y-1/2 p-[5px] flex items-center mobile450:right-[20px]"
                >
                    <span
                        className="inline-block w-[14px] h-[14px] indent-[-9999em] bg-no-repeat bg-cover"
                        style={{ backgroundImage: `url(${closeIcon})` }}
                    >
                        닫기
                    </span>
                </button>
            )}
        </header>
    );
}
